/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

export class BuildingsTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'buildings',
            'Buildings',
            allLabels.buildings,
            { numPairs: 6, ...options }
        );
    }
}
